import { render } from "./Matrix_Connections_includeByMother.vue?vue&type=template&id=d61d5c48&scoped=true"
import script from "./Matrix_Connections_includeByMother.vue?vue&type=script&lang=js"
export * from "./Matrix_Connections_includeByMother.vue?vue&type=script&lang=js"

import "./Matrix_Connections_includeByMother.vue?vue&type=style&index=0&id=d61d5c48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d61d5c48"]])

export default __exports__